// 存储临时变量
import zlVue from "@zhilian/zl-vue";
const tempGlobalData = zlVue.tempGlobalData
export default tempGlobalData;



// WEBPACK FOOTER //
// ./src/common/js/tempGlobalData.js